import { render, staticRenderFns } from "./SelecaoAssinatura.vue?vue&type=template&id=be6890c4&scoped=true&"
import script from "./SelecaoAssinatura.vue?vue&type=script&lang=js&"
export * from "./SelecaoAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./SelecaoAssinatura.vue?vue&type=style&index=0&id=be6890c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6890c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be6890c4')) {
      api.createRecord('be6890c4', component.options)
    } else {
      api.reload('be6890c4', component.options)
    }
    module.hot.accept("./SelecaoAssinatura.vue?vue&type=template&id=be6890c4&scoped=true&", function () {
      api.rerender('be6890c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/SelecaoAssinatura/SelecaoAssinatura.vue"
export default component.exports